
export default class CaregiverHistoryModel {
  constructor () {
    this.caregiverType = ''
    this.cases = 0
    this.shifts = 0
    this.matchedShifts = 0
    this.quotaShiftsLeft = 0
    this.list = []
  }

  static fromJSON (json) {
    let caregiver = new CaregiverHistoryModel()
    caregiver.caregiverType = json.caregiverType
    caregiver.cases = json.cases
    caregiver.shifts = json.shifts
    caregiver.matchedShifts = json.matchedShifts
    caregiver.quotaShiftsLeft = json.quotaShiftsLeft
    caregiver.list = json.list
    return caregiver
  }
}
